import * as swcHelpers from '@swc/helpers';

function touchFormFields(state) {
    return Object.entries(state).reduce((result, [key, value])=>{
        return swcHelpers.objectSpread({}, result, {
            [key]: swcHelpers.objectSpread({}, value, {
                isTouched: true
            })
        });
    }, {});
}
function touchComposedFormFields(state) {
    return Object.entries(state).reduce((result, [key, value])=>{
        return swcHelpers.objectSpread({}, result, {
            [key]: touchFormFields(value)
        });
    }, {});
}

export { touchComposedFormFields, touchFormFields };
//# sourceMappingURL=touch-form-fields.js.map
